module.exports = __webpack_public_path__ + "static/media/w5-t.61bdf98d.jpg";